import Axis from './axis.entity';
import Quadrant from './quadrant.entity';

export default class MatrixConfig {
  public id: string;

  public name: string;

  public description: string;

  public createdAt: string;

  public createdBy: string;

  public xAxis: Axis;

  public yAxis: Axis;

  public quadrants: Quadrant[];

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.createdAt = obj.createdAt || '';
    this.createdBy = obj.createdBy || '';
    this.xAxis = new Axis(obj.xAxis || {});
    this.yAxis = new Axis(obj.yAxis || {});
    this.quadrants = (obj.quadrants || []).map((q: any) => new Quadrant(q));
  }
}
